import { FormApi, GamificationApi, getHttpClient } from '@capsicum/common';

export const gamificationApi = getHttpClient.then(c => new GamificationApi(c));
export const formApi = getHttpClient.then(c => new FormApi(c));
